import { redirect } from "react-router-dom";

import { getAuthToken } from "../../util/authToken";

/** Logged-in users should use the app, not the sign-in screen. */
export async function loginLoader() {
  if (getAuthToken()) {
    throw redirect("/");
  }
  return null;
}
